import { render, staticRenderFns } from "./AdminSettingSideBar.vue?vue&type=template&id=2309e1e2"
import script from "./AdminSettingSideBar.vue?vue&type=script&lang=js"
export * from "./AdminSettingSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports